import React, { useState } from "react";
import { Placeholder, withSitecoreContext, Image } from "@sitecore-jss/sitecore-jss-react";
import { checkIsEditing } from "@clarion/foundation/dist/Utils/sitecoreUtils";
import "./index.css";
const HeaderGroup = ({
  fields,
  rendering,
  sitecoreContext
}) => {
  const isEditing = checkIsEditing(sitecoreContext);
  const imageParams = {
    w: 220,
    h: "auto",
    mw: 220
  };
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  return /*#__PURE__*/React.createElement("header", {
    id: "header",
    className: "header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header__wrapper wrapper wrapper--edge"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, isEditing ? /*#__PURE__*/React.createElement("span", {
    className: "header__logo"
  }, /*#__PURE__*/React.createElement(Image, {
    media: fields.Logo,
    width: "220",
    height: "77",
    imageParams: imageParams
  })) : /*#__PURE__*/React.createElement("a", {
    className: "header__logo",
    href: "/"
  }, /*#__PURE__*/React.createElement(Image, {
    media: fields.Logo,
    width: "220",
    height: "77",
    imageParams: imageParams
  }))), /*#__PURE__*/React.createElement("div", {
    className: "header__inner"
  }, /*#__PURE__*/React.createElement(Placeholder, {
    name: "navigation-group",
    rendering: rendering,
    isSearchOpen: isSearchOpen,
    setIsSearchOpen: setIsSearchOpen
  }))));
};
const HeaderGroupWithSitecoreContext = withSitecoreContext()(HeaderGroup);
export default HeaderGroupWithSitecoreContext;